module.exports = __webpack_public_path__ + "static/media/undraw-wine-tasting-30-vw.437b9387.svg";